import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-contact-history-review',
  templateUrl: './contact-history-review.component.html',
  styleUrls: ['./contact-history-review.component.scss'],
})
export class ContactHistoryReviewComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ContactHistoryReviewComponent>,
  ) {}

  close() {
    this.dialogRef.close();
  }
}
